<template>
  <div class='setFoodType'>
    <div class="wrapHeader">
      <el-form :inline="true" :model="checkFoodtype" class="demo-form-inline">
        <el-form-item label="油脂品种">
          <el-input v-model="checkFoodtype.foodName" placeholder="输入油脂品种"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getFoodtype">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class='setBgImg' :style="`height:${height+1}px`">
      <div class='showView' :style="`height:${height-20}px;width:${width-30}px`">
        <el-button type="primary" class='commonBtn addFoodType' icon='el-icon-circle-plus-outline' @click="addInfo">添加油脂品种</el-button>
        <div class='setMacView' :style="`height:${height-100}px;width:${width-60}px`">
          <el-table :data="foodTypeList" style="width: 100%" :border='true' :max-height="height-125" :header-cell-style='{"background":"rgba(48,56,255,0.03)"}'>
            <el-table-column type="index" width="60" align='center' label="序号"></el-table-column>
            <el-table-column prop="foodName" label="油脂品种" min-width="25%"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" min-width="30%"></el-table-column>
            <el-table-column label="操作" min-width="20%" align='center'>
              <template slot-scope="scope">
                <el-button @click.native.prevent="editInfo(scope.row.dataId)" type="text" size="small">修改</el-button>
                <el-button @click.native.prevent="deleteFoodType(scope.row.dataId)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="total,prev, pager, next"
            :total="total"
            :hide-on-single-page='true'
            :pageSize='checkFoodtype.pageSize' 
            :current-page='checkFoodtype.pageNum'
            @current-change='getOtherLog'
            class='setPosition'>
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="油脂品种信息" :visible.sync="foodTypeShow"
      :close-on-click-modal='false'
      :custom-class='"dialog-setBg dialog-foodType-bg"'>
      <div class='formWrap'>
        <el-form ref="foodTypeInfo" :model="foodTypeInfo" label-width="110px" class='foodTypeInfo' :rules='foodTypeRules'>
          <div class='dialog-setWrap dialog-foodType-wrap'>
            <div class='setfoodTypeInfo'>
              <el-form-item label="油脂品种" prop='foodName'>
                <el-input v-model="foodTypeInfo.foodName"></el-input>
              </el-form-item>
            </div>
          </div>
          <el-form-item class='saveBtn'>
            <el-button type="primary" @click="saveFoodType('foodTypeInfo')">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from '../../axios.js'
export default {
  props:{
    width:Number,
    height:Number
  },
  data(){
    return{
      checkFoodtype:{
        foodName:'',
        foodType:1,
        pageSize:10,
        pageNum:1
      },
      foodTypeList:[],
      foodTypeShow:false,
      foodTypeInfo:{
        dfoodName:'',
      },
      isAdd:false,
      foodTypeRules:{
        foodName:[
          {trigger:'blur',message:'油脂品种不能为空',required:true}
        ]
      },
      total:0
    }
  },
  created(){
    this.getFoodtype();
  },
  methods:{
    getOtherLog(val){
      this.checkFoodtype.pageNum=val
      this.getFoodtype();
    },
    getFoodtype(){
      axios.get('/system/foodoiltype/list',{params:this.checkFoodtype}).then(data=>{
        if(data){
          this.foodTypeList=data.rows;
          this.total=data.total;
        }
      })
    },
    addInfo(){
      this.isAdd=true;
      this.foodTypeShow=true;
      this.foodTypeInfo={
        foodName:'',
        foodType:1
      }
    },
    editInfo(dataId){
      axios.get(`/system/foodoiltype/${dataId}`).then(res=>{
        if(res){
          this.foodTypeInfo=res.data;
          this.foodTypeShow=true;
          this.isAdd=false;
        }
      })
    },
    deleteFoodType(dataIds){
      this.$confirm('此操作将永久删除该油脂品种, 是否继续?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios.delete(`/system/foodoiltype/${dataIds}`).then(data=>{
          if(data){
            this.getFoodtype();
            this.$message({
              type: 'success',
              message: '删除成功!',
              duration:1000
            });
          }
        })
      }).catch(()=>{
        this.$message({
          type: 'info',
          message: '已取消删除',
          duration:1000
        });   
      })
    },
    saveFoodType(obj){
      this.$refs[obj].validate((valid)=>{
        if(valid){
          if(this.isAdd){
            axios.post('/system/foodoiltype',this.foodTypeInfo).then(res=>{
              this.getFoodtype();
              this.$message({
                type: 'success',
                message: '添加成功!',
                duration:1000
              });
              this.foodTypeShow=false;
            })
          }else{
            axios.put('/system/foodoiltype',this.foodTypeInfo).then(res=>{
              this.getFoodtype();
              this.$message({
                type: 'success',
                message: '添加成功!',
                duration:1000
              });
              this.foodTypeShow=false;
            })
          }
        }else{
          return false
        }
      })
    }
  }
}
</script>

<style>
  .addFoodType{left: 15px;}
  .setFoodType{
    height: 100%;
    width: 100%;
    box-sizing: border-box;
  }
  .dialog-foodType-bg{
    width: 440px !important;
  }
  .dialog-foodType-wrap{
    height: 140px;
    width: 400px;
  }
  .setfoodTypeInfo{
    width: 300px;
    margin-left: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    box-sizing: border-box;
    padding: 10px
  }
</style>
